<script lang="ts">
  import clsx from 'clsx'
  import { fade } from 'svelte/transition'
  import videoStore from '../../stores/video.svelte'
  import componentAttributesStore from '../../stores/componentAttributes.svelte'
  import withPreventDefault from '../../utils/withPreventDefault'
  import BigPlaybackButton from './buttons/BigPlaybackButton.svelte'
  import VideoTitle from './VideoTitle.svelte'
  import PlayPauseActionOverlay from './PlayPauseActionOverlay.svelte'
  import type { Snippet } from 'svelte'

  type Props = {
    children?: Snippet
  }

  let { children }: Props = $props()

  let isPlayPauseTriggered: boolean = $state(false)

  const triggerPlayPause = () => {
    videoStore.state.videoController.togglePlayPause()
    videoStore.mouseMove()
    if (!isPlayPauseTriggered) {
      isPlayPauseTriggered = true
    }
  }
</script>

<!-- svelte-ignore a11y_click_events_have_key_events -->
<!-- svelte-ignore a11y_no_static_element_interactions -->
{#if !componentAttributesStore.state.hideControls}
  <div
    class="absolute bottom-0 left-0 w-full h-full flex items-center justify-center"
    onclick={(e) => withPreventDefault(e, triggerPlayPause)}
  >
    <PlayPauseActionOverlay bind:isPlayPauseTriggered />
    {#if videoStore.state.settingsMenuOpen}
      <div
        onclick={(e) =>
          withPreventDefault(
            e,
            () => (videoStore.state.settingsMenuOpen = false),
          )}
        class="absolute bottom-0 left-0 w-full h-full flex items-center justify-center z-30"
      ></div>
    {/if}
    <VideoTitle />
    {#if videoStore.showControls() || !videoStore.state.isPlaying}
      <div
        class="bg-overlayGradientBottomToTop h-full absolute top-0 left-0 w-full"
        transition:fade={{ duration: 100 }}
      ></div>

      {#if !videoStore.state.isBuffering}<BigPlaybackButton />{/if}
    {/if}
    {@render children?.()}
  </div>
{/if}
